/*
 * 月卡订单相关 API
 */
import request from '@/utils/request'

/**
 * 创建月卡订单（商户月卡 B 类）
 * @param {Object} data 月卡订单参数
 */
export function createMonthlyCardOrder (data) {
  return request({
    url: '/market/card/order/add',
    method: 'post',
    data
  })
}

/**
 * 取消月卡订单
 * @param {string} orderId 订单ID
 */
export function cancelMonthlyCardOrder (orderId) {
  return request({
    url: '/market/card/order/cancel',
    method: 'post',
    params: { id: orderId }
  })
}

/**
 * 获取月卡订单列表（分页）
 * @param {Object} params 查询参数
 * @param {number} page 页码
 * @param {number} size 每页大小
 */
export function getMonthlyCardOrderList (params, page = 1, size = 100) {
  return request({
    url: '/market/card/order/search/page',
    method: 'post',
    data: params,
    params: { page, size }
  })
}

